import { OnlineProvider } from '@/data/OnlineProvider'
import { generateSignalDataAccess } from '@/react/utils/generateSignalDataAccess'

export const [onlineProviders0, makeOnlineProviderAvailable] = generateSignalDataAccess(OnlineProvider, { convertOpts: { autoSave: true } })

//@ts-ignore
window.onlineProviders0 = onlineProviders0